import React from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { ROLE } from '../../../configs/exports';

const SidebarContent = ({
  onClick, changeToLight, changeToDark, sidebarCollapse,
}) => {
  const hideSidebar = () => {
    onClick();
  };

  return (
    <div className="sidebar__content">
      {ROLE === '1' ?
        <>
          <SidebarLink
            title="Search Customer"
            icon="user"
            route="/find_user"
            onClick={hideSidebar}
          />
          <SidebarCategory title="Finance" icon="briefcase">

            <SidebarLink title="Gaming Income" route="/game_income" onClick={hideSidebar} />
            <SidebarLink title="EWallet" route="/ewallet" onClick={hideSidebar} />

            <SidebarLink title="NetCashFlow" route="/netcashflow" onClick={hideSidebar} />
            <SidebarCategory title="Deposits">
              <SidebarLink title="Deposit Requests" route="/deposit_requests" onClick={hideSidebar} />
              <SidebarLink title="Daily Deposits" route="/daily_deposits" onClick={hideSidebar} />
              <SidebarLink title="Deposits Per Hour" route="/deposit_per_hour" onClick={hideSidebar} />


            </SidebarCategory>


            <SidebarCategory title="Withdrawals">
              <SidebarLink title="Withdrawals Summary" route="/daily_withdrawal" onClick={hideSidebar} />
              <SidebarLink title="Withdrawals" route="/withdrawal_request" onClick={hideSidebar} />
            </SidebarCategory>
          </SidebarCategory>


          <ul className="sidebar__block">

            <SidebarLink title="Ledger" route="/ledger" icon="briefcase" onClick={hideSidebar} />
            <SidebarLink title="Winners" route="/winners" icon="bullhorn" onClick={hideSidebar} />

          </ul>

          <SidebarCategory title="Bets" icon="book" >
            <SidebarLink title="Time Played" route="/time_played" onClick={hideSidebar} />

            <SidebarLink title="Bets Per Day" route="/bet_per_day" onClick={hideSidebar} />
            <SidebarLink title="Bets Per Hour" route="/bet_per_hour" onClick={hideSidebar} />
            {/* <SidebarLink title="Other Winners" route="/otherwinners" onClick={this.hideSidebar} /> */}
            <SidebarLink title="Average Bets" route="/avarage_bet" onClick={hideSidebar} />
          </SidebarCategory>


          <SidebarCategory title="Mpesa Reconciliation" icon="briefcase">
            <SidebarLink title="Mpesa Reconciliation" route="/reconciliation" onClick={hideSidebar} />
          </SidebarCategory>


          <ul className="sidebar__block">
            <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={hideSidebar} />


            <SidebarCategory title="Blast" icon="briefcase">
              <SidebarLink title="Active Customers" route="/sendblast" onClick={hideSidebar} />

              <SidebarLink title="Never Played" route="/sendInactiveBlast" onClick={hideSidebar} />
            </SidebarCategory>

          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="Audit Trails" icon="briefcase">
              <SidebarLink title="Login Audits" route="/login_audit" onClick={hideSidebar} />
              {/* <SidebarLink title="Customer Perfomance" route="/audit_performance" onClick={this.hideSidebar} /> */}
            </SidebarCategory>
          </ul>

        </>
        : null}










      {ROLE === '3' ?
        <>
          <SidebarLink
            title="Search Customer"
            icon="user"
            route="/find_user"
            onClick={hideSidebar}
          />
          <ul className="sidebar__block">
          <SidebarLink title="Winners" route="/winners" icon="bullhorn" onClick={hideSidebar} />

            <SidebarLink title="Blacklist" route="/blacklist" icon="users" onClick={hideSidebar} />


           
          </ul>


        </>
        : null
      }

      {
        ROLE === '1' ?
          <>
          </>
          : null
      }




      <ul className="sidebar__block">
        <SidebarCategory title="Layout" icon="layers" sidebarCollapse={sidebarCollapse}>
          <button className="sidebar__link" type="button" onClick={changeToLight}>
            <p className="sidebar__link-title">Light Theme</p>
          </button>
          <button className="sidebar__link" type="button" onClick={changeToDark}>
            <p className="sidebar__link-title">Dark Theme</p>
          </button>
        </SidebarCategory>

      </ul>
      <ul className="sidebar__block">
        <SidebarLink title="Log Out" icon="exit" route="/log_in" />
      </ul>
      <ul className="sidebar__block">
        <SidebarLink
          title="Documentation"
          icon="text-align-justify"
          route="/documentation/introduction"
          onClick={hideSidebar}
        />
      </ul>
    </div >
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  sidebarCollapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  sidebarCollapse: false,
};

export default SidebarContent;
